<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
import { f7, f7ready } from "framework7-svelte";
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { Readable } from "svelte/store";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { CardsTabContext, CardsTabContextKey, } from "../../../common/context";
import { getContext, onMount } from "svelte";
import moment from 'moment';
import { JanusSignonManager, JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import TextInput from "../TextInput/TextInput.svelte";
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
$: key = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.key) || "birthdate";
$: label = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.label) || "Date of Birth";
let ageRestrictionMet = false;
$: ageRestrictionMin = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.ageRestrictionMin) || 18;
$: error = birthdate && !ageRestrictionMet && `Must be ${ageRestrictionMin} years of age or older.`;
// $: mask = element?.data?.mask as string || "00/00/0000";
// $: maskString = element?.data?.maskString as string || "MM/DD/YYYY";
const signonManager = getToken(ROOT, JanusSignonManagerToken);
let birthdate;
function calculateAge(birthdate) {
    try {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }
    catch (error) {
        // Reset birthdate so there's no chance of bad data being passed around
        birthdate = null;
        tabContext.setParam(key, null);
    }
}
function checkAgeRestriction(age) {
    ageRestrictionMet = age >= ageRestrictionMin;
    if (!ageRestrictionMet) {
        tabContext.setParam(key, null);
    }
}
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    const profileData = yield signonManager.getUserProfileSegment();
    const data = (profileData === null || profileData === void 0 ? void 0 : profileData.data) || {};
    console.log('profileData: ', data);
    try {
        const ssoBirthdate = data.birth_date ? new Date((data.birth_date.length === 10 && !data.birth_date.includes('T')) ? `${data.birth_date}T00:00:00` : data.birth_date) : null;
        if (ssoBirthdate && !birthdate) {
            birthdate = moment(ssoBirthdate, format);
            tabContext.setParam(key, birthdate === null || birthdate === void 0 ? void 0 : birthdate.toISOString(true).slice(0, 10));
            birthdate = birthdate.format(format);
            const age = calculateAge(data.birth_date);
            checkAgeRestriction(age);
        }
    }
    catch (error) {
        // Was not able to parse birth date for one reason or another.
        // Reset birthdate so there's no chance of bad data being passed around
        birthdate = null;
        tabContext.setParam(key, null);
    }
}));
let calendar;
let format = 'MM/DD/YYYY';
const placeholder = format;
onMount(() => {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    calendar = f7.calendar.create({
        inputEl: "#sso22-demo-calendar-events",
        closeOnSelect: true,
        events: [
            //- more events this day
            {
                date: today,
                color: "#ff0000",
            },
            {
                date: today,
                color: "#00ff00",
            },
        ],
    });
    calendar.on("dayClick", (calendar, dayEl, year, month, day) => {
        try {
            let date = moment(new Date(year, month, day));
            tabContext.setParam(key, date === null || date === void 0 ? void 0 : date.toISOString(true).slice(0, 10));
            birthdate = date.format(format);
            const age = calculateAge(date);
            checkAgeRestriction(age);
        }
        catch (error) {
            // Reset birthdate so there's no chance of bad data being passed around
            birthdate = null;
            tabContext.setParam(key, null);
        }
    });
});
const minDate = new Date("1900-01-01");
const maxDate = new Date("2023-01-01");
$: if (calendar && birthdate) {
    try {
        let date = moment(birthdate, format);
        calendar.setValue([date]);
    }
    catch (error) {
        // Reset birthdate so there's no chance of bad data being passed around
        birthdate = null;
        tabContext.setParam(key, null);
    }
}
</script>

<CardBase {element}>
<div class="wrapper">
  <TextInput id="sso22-demo-calendar-events" className="input" readonly={true} placeholder={label} value={birthdate || ''} onChange={() => {}} {error} />
</div>
</CardBase>

<style>.wrapper {
  display: block;
  text-align: left;
  width: 100%;
}

.input {
  width: 100% !important;
  height: 40px !important;
  border-radius: 6px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #000000;
  padding-left: 16px;
  background: #FFFFFF;
  border: 1px solid #D8D8D8;
  padding-right: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  display: block;
  position: relative;
}

:global(::-webkit-input-placeholder) { /* Chrome/Opera/Safari */
  color: black;
}

:global(:-moz-placeholder) { /* Firefox 19+ */
  color: black;
}

:global(:-ms-input-placeholder) { /* IE 10+ */
  color: black;
}

:global(:-moz-placeholder) { /* Firefox 18- */
  color: black;
}

:global(.calendar-months) {
  background: white;
}

:global(.calendar-day.calendar-day-selected .calendar-day-number) {
  color: var(--f7-calendar-selected-text-color);
  background-color: var(--alav-s-secondary);
}

:global(.calendar .toolbar a) {
  color: var(--alav-s-secondary);
}</style>
